import type { UserResponse } from 'types/session/user'

import type { LoginServiceErrors } from '../types/loginService'

type SessionAuthenticateResponse = LoginServiceErrors | UserResponse | null

export const isLoginFieldsError = (
	loginServiceResponse: SessionAuthenticateResponse
): loginServiceResponse is LoginServiceErrors =>
	!!(loginServiceResponse as LoginServiceErrors).errorFields
